export const avaiableLanguage = ["IT", "EN", "ES", "DE"]
export const availableCoutries = [
    [
        "Italia",
        "IT"
    ],
    [
        "Albania",
        "AL"
    ],
    [
        "Andorra",
        "AD"
    ],
    [
        "Armenia",
        "AM"
    ],
    [
        "Austria",
        "AT"
    ],
    [
        "Azerbaigian",
        "AZ"
    ],
    [
        "Belgio",
        "BE"
    ],
    [
        "Bielorussia",
        "BY"
    ],
    [
        "Bosnia-Erzegovina",
        "BA"
    ],
    [
        "Bulgaria",
        "BG"
    ],
    [
        "Cipro",
        "CY"
    ],
    [
        "Santa Sede (Stato della Città del Vaticano)",
        "VA"
    ],
    [
        "Croazia",
        "HR"
    ],
    [
        "Danimarca",
        "DK"
    ],
    [
        "Estonia",
        "EE"
    ],
    [
        "Finlandia",
        "FI"
    ],
    [
        "Francia",
        "FR"
    ],
    [
        "Georgia",
        "GE"
    ],
    [
        "Germania",
        "DE"
    ],
    [
        "Grecia",
        "GR"
    ],
    [
        "Irlanda",
        "IE"
    ],
    [
        "Islanda",
        "IS"
    ],
    [
        "Kazakistan",
        "KZ"
    ],
    [
        "Lettonia",
        "LV"
    ],
    [
        "Liechtenstein",
        "LI"
    ],
    [
        "Lituania",
        "LT"
    ],
    [
        "Lussemburgo",
        "LU"
    ],
    [
        "Repubblica di Macedonia",
        "MK"
    ],
    [
        "Malta",
        "MT"
    ],
    [
        "Moldavia",
        "MD"
    ],
    [
        "Monaco",
        "MC"
    ],
    [
        "Montenegro",
        "ME"
    ],
    [
        "Norvegia",
        "NO"
    ],
    [
        "Paesi Bassi",
        "NL"
    ],
    [
        "Polonia",
        "PL"
    ],
    [
        "Portogallo",
        "PT"
    ],
    [
        "Regno Unito",
        "GB"
    ],
    [
        "Repubblica Ceca",
        "CZ"
    ],
    [
        "Romania",
        "RO"
    ],
    [
        "Russia",
        "RU"
    ],
    [
        "San Marino",
        "SM"
    ],
    [
        "Serbia",
        "RS"
    ],
    [
        "Slovacchia",
        "SK"
    ],
    [
        "Slovenia",
        "SI"
    ],
    [
        "Spagna",
        "ES"
    ],
    [
        "Svezia",
        "SE"
    ],
    [
        "Svizzera",
        "CH"
    ],
    [
        "Turchia",
        "TR"
    ],
    [
        "Ucraina",
        "UA"
    ],
    [
        "Ungheria",
        "HU"
    ],
    [
        "Afghanistan",
        "AF"
    ],
    [
        "Algeria",
        "DZ"
    ],
    [
        "Angola",
        "AO"
    ],
    [
        "Anguilla",
        "AI"
    ],
    [
        "Antartide",
        "AQ"
    ],
    [
        "Antigua e Barbuda",
        "AG"
    ],
    [
        "Arabia Saudita",
        "SA"
    ],
    [
        "Argentina",
        "AR"
    ],
    [
        "Aruba",
        "AW"
    ],
    [
        "Australia",
        "AU"
    ],
    [
        "Bahamas",
        "BS"
    ],
    [
        "Bahrein",
        "BH"
    ],
    [
        "Bangladesh",
        "BD"
    ],
    [
        "Barbados",
        "BB"
    ],
    [
        "Belize",
        "BZ"
    ],
    [
        "Benin",
        "BJ"
    ],
    [
        "Bermuda",
        "BM"
    ],
    [
        "Bhutan",
        "BT"
    ],
    [
        "Bolivia, Stato Plurinazionale",
        "BO"
    ],
    [
        "Bonaire, Saint Eustatius e Saba",
        "BQ"
    ],
    [
        "Botswana",
        "BW"
    ],
    [
        "Brasile",
        "BR"
    ],
    [
        "Brunei",
        "BN"
    ],
    [
        "Burkina-Faso",
        "BF"
    ],
    [
        "Burundi",
        "BI"
    ],
    [
        "Cambogia",
        "KH"
    ],
    [
        "Camerun",
        "CM"
    ],
    [
        "Canada",
        "CA"
    ],
    [
        "Capo Verde",
        "CV"
    ],
    [
        "Ciad",
        "TD"
    ],
    [
        "Cile",
        "CL"
    ],
    [
        "Cina",
        "CN"
    ],
    [
        "Colombia",
        "CO"
    ],
    [
        "Comore",
        "KM"
    ],
    [
        "Congo",
        "CG"
    ],
    [
        "Corea del Nord",
        "KP"
    ],
    [
        "Corea del Sud",
        "KR"
    ],
    [
        "Costa Rica",
        "CR"
    ],
    [
        "Costa d'Avorio",
        "CI"
    ],
    [
        "Cuba",
        "CU"
    ],
    [
        "Curaçao",
        "CW"
    ],
    [
        "Dominica",
        "DM"
    ],
    [
        "Ecuador",
        "EC"
    ],
    [
        "Egitto",
        "EG"
    ],
    [
        "El Salvador",
        "SV"
    ],
    [
        "Emirati arabi uniti",
        "AE"
    ],
    [
        "Eritrea",
        "ER"
    ],
    [
        "Etiopia",
        "ET"
    ],
    [
        "Fiji",
        "FJ"
    ],
    [
        "Filippine",
        "PH"
    ],
    [
        "Gabon",
        "GA"
    ],
    [
        "Gambia",
        "GM"
    ],
    [
        "Georgia del Sud e Sandwich australi",
        "GS"
    ],
    [
        "Ghana",
        "GH"
    ],
    [
        "Giamaica",
        "JM"
    ],
    [
        "Giappone",
        "JP"
    ],
    [
        "Gibilterra",
        "GI"
    ],
    [
        "Gibuti",
        "DJ"
    ],
    [
        "Giordania",
        "JO"
    ],
    [
        "Grenada",
        "GD"
    ],
    [
        "Groenlandia",
        "GL"
    ],
    [
        "Guadalupa",
        "GP"
    ],
    [
        "Guam",
        "GU"
    ],
    [
        "Guatemala",
        "GT"
    ],
    [
        "Guernsey",
        "GG"
    ],
    [
        "Guinea equatoriale",
        "GQ"
    ],
    [
        "Guinea",
        "GN"
    ],
    [
        "Guinea-Bissau",
        "GW"
    ],
    [
        "Guyana francese",
        "GF"
    ],
    [
        "Guyana",
        "GY"
    ],
    [
        "Haiti",
        "HT"
    ],
    [
        "Honduras",
        "HN"
    ],
    [
        "Hong Kong",
        "HK"
    ],
    [
        "India",
        "IN"
    ],
    [
        "Indonesia",
        "ID"
    ],
    [
        "Iran",
        "IR"
    ],
    [
        "Iraq",
        "IQ"
    ],
    [
        "Isola Christmas",
        "CX"
    ],
    [
        "Isola Norfolk",
        "NF"
    ],
    [
        "Isola di Bouvet",
        "BV"
    ],
    [
        "Isola di Man",
        "IM"
    ],
    [
        "Isole Åland",
        "AX"
    ],
    [
        "Isole Cayman",
        "KY"
    ],
    [
        "Isole Cocos (Keeling)",
        "CC"
    ],
    [
        "Isole Cook",
        "CK"
    ],
    [
        "Isole Falkland (Malvine)",
        "FK"
    ],
    [
        "Isole Fær Øer",
        "FO"
    ],
    [
        "Isole Heard e McDonald",
        "HM"
    ],
    [
        "Isole Marshall",
        "MH"
    ],
    [
        "Isole Salomone",
        "SB"
    ],
    [
        "Isole Turks e Caicos",
        "TC"
    ],
    [
        "Isole Vergini britanniche",
        "VG"
    ],
    [
        "Isole Vergini, U.S.",
        "VI"
    ],
    [
        "Isole minori statunitensi",
        "UM"
    ],
    [
        "Israele",
        "IL"
    ],
    [
        "Jersey",
        "JE"
    ],
    [
        "Kenya",
        "KE"
    ],
    [
        "Kirghizistan",
        "KG"
    ],
    [
        "Kiribati",
        "KI"
    ],
    [
        "Kossovo",
        "XK"
    ],
    [
        "Kuwait",
        "KW"
    ],
    [
        "Laos",
        "LA"
    ],
    [
        "Lesotho",
        "LS"
    ],
    [
        "Libano",
        "LB"
    ],
    [
        "Liberia",
        "LR"
    ],
    [
        "Libia",
        "LY"
    ],
    [
        "Macao",
        "MO"
    ],
    [
        "Madagascar",
        "MG"
    ],
    [
        "Malawi",
        "MW"
    ],
    [
        "Malaysia",
        "MY"
    ],
    [
        "Maldive",
        "MV"
    ],
    [
        "Mali",
        "ML"
    ],
    [
        "Marianne settentrionali",
        "MP"
    ],
    [
        "Marocco",
        "MA"
    ],
    [
        "Martinica",
        "MQ"
    ],
    [
        "Mauritania",
        "MR"
    ],
    [
        "Maurizio",
        "MU"
    ],
    [
        "Mayotte",
        "YT"
    ],
    [
        "Messico",
        "MX"
    ],
    [
        "Micronesia",
        "FM"
    ],
    [
        "Mongolia",
        "MN"
    ],
    [
        "Montserrat",
        "MS"
    ],
    [
        "Mozambico",
        "MZ"
    ],
    [
        "Myanmar",
        "MM"
    ],
    [
        "Namibia",
        "NA"
    ],
    [
        "Nauru",
        "NR"
    ],
    [
        "Nepal",
        "NP"
    ],
    [
        "Nicaragua",
        "NI"
    ],
    [
        "Niger",
        "NE"
    ],
    [
        "Nigeria",
        "NG"
    ],
    [
        "Niue",
        "NU"
    ],
    [
        "Nuova Caledonia",
        "NC"
    ],
    [
        "Nuova Zelanda",
        "NZ"
    ],
    [
        "Oman",
        "OM"
    ],
    [
        "Pakistan",
        "PK"
    ],
    [
        "Palau",
        "PW"
    ],
    [
        "Palestina, Stato di",
        "PS"
    ],
    [
        "Panama",
        "PA"
    ],
    [
        "Papua Nuova Guinea",
        "PG"
    ],
    [
        "Paraguay",
        "PY"
    ],
    [
        "Perù",
        "PE"
    ],
    [
        "Pitcairn",
        "PN"
    ],
    [
        "Polinesia francese",
        "PF"
    ],
    [
        "Puerto Rico",
        "PR"
    ],
    [
        "Qatar",
        "QA"
    ],
    [
        "Repubblica Centrafricana",
        "CF"
    ],
    [
        "Repubblica Dominicana",
        "DO"
    ],
    [
        "Repubblica democratica del Congo",
        "CD"
    ],
    [
        "Riunione",
        "RE"
    ],
    [
        "Ruanda",
        "RW"
    ],
    [
        "Sahara occidentale",
        "EH"
    ],
    [
        "Saint Helena, Ascension e Tristan da Cunha",
        "SH"
    ],
    [
        "Saint Kitts e Nevis",
        "KN"
    ],
    [
        "Saint Lucia",
        "LC"
    ],
    [
        "Saint Vincent e Grenadine",
        "VC"
    ],
    [
        "Saint-Barths",
        "BL"
    ],
    [
        "Saint-Martin (Francia)",
        "MF"
    ],
    [
        "Saint-Pierre e Miquelon",
        "PM"
    ],
    [
        "Samoa americane",
        "AS"
    ],
    [
        "Samoa",
        "WS"
    ],
    [
        "São Tomé e Príncipe",
        "ST"
    ],
    [
        "Seicelle",
        "SC"
    ],
    [
        "Senegal",
        "SN"
    ],
    [
        "Sierra Leone",
        "SL"
    ],
    [
        "Singapore",
        "SG"
    ],
    [
        "Sint Maarten (parte olandese)",
        "SX"
    ],
    [
        "Siria",
        "SY"
    ],
    [
        "Somalia",
        "SO"
    ],
    [
        "Sri Lanka",
        "LK"
    ],
    [
        "Stati Uniti",
        "US"
    ],
    [
        "Sud Africa",
        "ZA"
    ],
    [
        "Sudan meridionale",
        "SS"
    ],
    [
        "Sudan",
        "SD"
    ],
    [
        "Suriname",
        "SR"
    ],
    [
        "Svalbard e Jan Mayen",
        "SJ"
    ],
    [
        "Swaziland",
        "SZ"
    ],
    [
        "Tagikistan",
        "TJ"
    ],
    [
        "Taiwan",
        "TW"
    ],
    [
        "Tanzania",
        "TZ"
    ],
    [
        "Territori meridionali francesi",
        "TF"
    ],
    [
        "Territorio britannico dell'Oceano Indiano",
        "IO"
    ],
    [
        "Thailandia",
        "TH"
    ],
    [
        "Timor orientale",
        "TL"
    ],
    [
        "Togo",
        "TG"
    ],
    [
        "Tokelau",
        "TK"
    ],
    [
        "Tonga",
        "TO"
    ],
    [
        "Trinidad e Tobago",
        "TT"
    ],
    [
        "Tunisia",
        "TN"
    ],
    [
        "Turkmenistan",
        "TM"
    ],
    [
        "Tuvalu",
        "TV"
    ],
    [
        "Uganda",
        "UG"
    ],
    [
        "Uruguay",
        "UY"
    ],
    [
        "Uzbekistan",
        "UZ"
    ],
    [
        "Vanuatu",
        "VU"
    ],
    [
        "Venezuela, Repubblica bolivariana",
        "VE"
    ],
    [
        "Vietnam",
        "VN"
    ],
    [
        "Wallis e Futuna",
        "WF"
    ],
    [
        "Yemen",
        "YE"
    ],
    [
        "Zambia",
        "ZM"
    ],
    [
        "Zimbabwe",
        "ZW"
    ]
]